/** Shared status chip styling for spent-hours tables (Activity log, Spent hours, Daily report). */
export function spentHoursStatusPill(statusLabel: string, rawValue: string) {
  const combined = `${statusLabel} ${rawValue}`.toLowerCase();
  const base =
    "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold";

  /* Approved / Completed — light mint bg, soft green border, dark green text */
  if (combined.includes("approv") || combined.includes("completed")) {
    return (
      <span className={`${base} border-[#C8E6C9] bg-[#E8F5E9] text-[#2E7D32]`}>
        {statusLabel}
      </span>
    );
  }

  /* Draft / in progress — cream bg, soft amber border, golden-brown text */
  if (
    combined.includes("work_in_progress") ||
    combined.includes("progress") ||
    combined.includes("draft")
  ) {
    return (
      <span className={`${base} border-[#fd7] bg-[#FFF8E1] text-[#B8860B]`}>
        {statusLabel}
      </span>
    );
  }

  /* Rejected / blocked / need help / default — pale pink bg, soft red border, red text */
  return (
    <span className={`${base} border-[#FFC1C1] bg-[#FFF0F0] text-[#F44336]`}>
      {statusLabel}
    </span>
  );
}
